import axios from 'axios';
import connection from './connection';
import {AllCodeListMainResponseModel, CodeListMainDto, CodeListMainIdRequest, CodeListResponseModel, CodeListValidationReq} from '@gtpl/shared-models/planning'
import { CommonResponse } from '@gtpl/shared-models/masters';


export class CodeListMainService {
  URL = connection.DEPLOY_URL + '/code-list-main';

  async createCodeListInfo(codeList: CodeListMainDto): Promise<CommonResponse> {
    return await axios
      .post(this.URL + '/createCodeListInfo', codeList)
      .then((res) => {
        return res.data;
      });
  }

  async getAllCodeLists(): Promise<AllCodeListMainResponseModel> {
    return await axios
      .post(this.URL + '/getAllCodeLists')
      .then((res) => {
        return res.data;
      });
  }
  async updateCodeList(codeListMainDto: CodeListMainDto): Promise<CodeListResponseModel> {
    return await axios
      .post(this.URL + '/updateCodeList',codeListMainDto)
      .then((res) => {
        return res.data;
      });
  }

  async activateOrDeactivateProduct(codeListReq: CodeListMainDto): Promise<CodeListResponseModel> {
    return await axios
      .post(this.URL + '/activateOrDeactivateProduct',codeListReq)
      .then((res) => {
        return res.data;
      });
  }

  async getCodeListsForId(codeListReq:CodeListMainIdRequest ): Promise<CommonResponse> {
    return await axios
      .post(this.URL + '/getCodeListsForId',codeListReq)
      .then((res) => {
        return res.data;
      });
  }

  async geTracebilityCodeForSoId(codeListReq:CodeListMainIdRequest ): Promise<CommonResponse> {
    return await axios
      .post(this.URL + '/geTracebilityCodeForSoId',codeListReq)
      .then((res) => {
        return res.data;
      });
  }
  
  async validateCodeListCartons(codeListReq:CodeListValidationReq ): Promise<CommonResponse> {
    return await axios
      .post(this.URL + '/validateCodeListCartons',codeListReq)
      .then((res) => {
        return res.data;
      });
  }
  
}
